// Single source of truth for the backend API base URL.
//
// - Web (served behind nginx): the default "/api" relative path, which nginx
//   proxies to the backend. Same-origin, so this just works in a browser.
// - Native app builds (Capacitor) or any other host without the nginx proxy:
//   set an ABSOLUTE base (e.g. "https://www.gearcheckauto.com/api") via
//   REACT_APP_API_BASE - either at build time (process.env) or at runtime
//   (window.__ENV__, injected by docker-entrypoint.d/40-env-config.sh, mirroring
//   how REACT_APP_MAPBOX_TOKEN is provided).
//
// A relative "/api" path has no origin inside a native WebView (the app is
// loaded from capacitor://localhost or a bundled file), so every fetch must go
// through this resolved base instead of hard-coding "/api".

function resolveApiBase() {
  const runtime =
    typeof window !== "undefined" &&
    window.__ENV__ &&
    typeof window.__ENV__.REACT_APP_API_BASE === "string"
      ? window.__ENV__.REACT_APP_API_BASE.trim()
      : "";
  // Read the build-time value directly: CRA (react-scripts) statically replaces
  // `process.env.REACT_APP_*` with a literal at build time, so this is NOT a runtime
  // `process` lookup. Do NOT guard it behind `typeof process !== "undefined"` - that
  // guard is evaluated at runtime, is false in the browser (no global `process`), and
  // would discard the compiled-in value, silently falling back to "/api". (This is how
  // REACT_APP_MAPBOX_TOKEN is read elsewhere.)
  const build = process.env.REACT_APP_API_BASE
    ? String(process.env.REACT_APP_API_BASE).trim()
    : "";

  const base = runtime || build || "/api";
  // Normalize away any trailing slash so callers can always do `${API_BASE}/path`.
  return base.replace(/\/+$/, "");
}

export const API_BASE = resolveApiBase();
